/**
 * @file 标题块内容
 */
import {
  faChevronDown,
  faChevronLeft,
} from '@fortawesome/pro-regular-svg-icons'
import { ButtonIcon, Input } from '@seiue/ui'
import { useAtomValue } from 'jotai'
import styled, { css } from 'styled-components'

import { BlockStateEnum } from 'packages/feature-utils/test-paper'
import { BlockTypeEnum } from 'packages/sdks-next/growp'

import { collapsedHeaderIdsAtom } from '../../BlockList/atoms'
import { BlockComponent } from '../../BlockWrapper/types'

/**
 * 标题块内容
 *
 * @param root0 - FC Props
 * @param root0.blockData - 块数据
 * @param root0.state - 块状态
 * @param root0.onChangeBlockData - 更新块数据
 * @param root0.onSave - 保存
 * @param root0.onChangeState - 更新块状态
 * @param root0.toggleCollapse - 折叠标题组
 * @returns 标题块内容
 */
export const HeaderBlock: BlockComponent = ({
  blockData,
  state,
  onChangeBlockData,
  onSave,
  onChangeState,
  toggleCollapse,
}) => {
  const collapsedHeaderIds = useAtomValue(collapsedHeaderIdsAtom)

  const renderContent = () => {
    if (state === BlockStateEnum.Editing) {
      return (
        <Input
          value={blockData.content}
          onChange={(e) => {
            onChangeBlockData({
              content: e.target.value,
            })
          }}
          onPressEnter={async () => {
            onChangeState(BlockStateEnum.Display)
            await onSave()
          }}
          onBlur={async () => {
            onChangeState(BlockStateEnum.Display)
            await onSave()
          }}
          onFocus={(e) => e.target.select()}
          autoFocus={true}
        />
      )
    }

    return (
      <div
        onClick={() => onChangeState(BlockStateEnum.Selected)}
        onDoubleClick={() => onChangeState(BlockStateEnum.Editing)}
      >
        {blockData.content}
      </div>
    )
  }

  return (
    <Wrapper>
      <HeaderWrapper $type={blockData.type}>
        {renderContent()}
        <ButtonCollapsed
          icon={
            collapsedHeaderIds.includes(blockData.id)
              ? faChevronLeft
              : faChevronDown
          }
          onClick={() => {
            toggleCollapse?.(!collapsedHeaderIds.includes(blockData.id))
          }}
        />
      </HeaderWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  border-radius: 4px;
`

const ButtonCollapsed = styled(ButtonIcon)`
  &&& {
    position: absolute;
    right: 16px;
    top: 50%;
    padding-left: 25px;
    transform: translateY(-50%);
    &:hover {
      background-color: transparent;
    }
  }
`

const HeaderWrapper = styled.div<{ $type: BlockTypeEnum }>`
  position: relative;
  color: ${(props) => props.theme.text._1};

  > * {
    border-radius: 8px;
    padding: 8px 16px;

    &::after {
      content: 'x';
      color: transparent;
    }

    ${({ $type }) =>
      $type === BlockTypeEnum.FirstLevelTitle
        ? css`
            font-size: 24px;
            line-height: 33.6px;
          `
        : $type === BlockTypeEnum.SecondLevelTitle
        ? css`
            font-size: 20px;
            line-height: 30px;
          `
        : $type === BlockTypeEnum.ThirdLevelTitle
        ? css`
            font-size: 18px;
            line-height: 28px;
          `
        : $type === BlockTypeEnum.FourthLevelTitle
        ? css`
            font-size: 16px;
            line-height: 24px;
          `
        : null};
  }
`
